import React from 'react'
import { ContactUsButton } from '../../../components/ContactUsButton'

export default function HelpContent() {
  return (
    <div className="box text-center">
      <h3>Did you find what you were looking for？</h3>

      <ContactUsButton text="No, I need help!" />
    </div>
  )
}
